import {ICampaignStatusEnum} from '../../campaigns/interfaces/ICampaigns';
import OrderLists from '../components/list';

const OrderRejected = () => {
  return <OrderLists status={ICampaignStatusEnum.REJECT} />;
};

export default OrderRejected;
